import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JiraProjectAri } from '@atlassian/ari/jira';
import OptInModalQuery from './__generated__/OptInModalQuery.graphql';

type EntryPointParams = { cloudId: string; projectId: string };

export const optInModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() => {
		return import(
			/* webpackChunkName: "async-legacy-cmp-project-settings-fields-OptInModal" */ './OptInModal.tsx'
		);
	}),
	getPreloadProps: (params: EntryPointParams) => {
		return {
			queries: {
				projectData: {
					parameters: OptInModalQuery,
					variables: {
						projectAri: JiraProjectAri.create({
							siteId: params.cloudId,
							projectId: params.projectId,
						}).toString(),
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
